import React, { ReactNode, useContext, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Box } from '@material-ui/core'
import { Case, Switch, When } from 'react-if'
import RootStoreContext from '../../../storage/RootStore'
import { CloseIcon } from '../../Icon/Close'
import { IOrgStageCoordsGetterOutput } from '../../Matrix/functions/getOrgStages-1'
import { getStageInfo, getStagesForOrg } from '../../../dict/STAGES'
import { getDocInfo, getDocsForOrg } from '../../../dict/DOCS'
import { getOrgInfo } from '../../../dict/ORGS'
import { getProblemInfo } from '../../../dict/PROBLEMS'
import { Stages } from './Stages'
import { Organizations } from './Organizations'
import { Documents } from './Documents'
import { Problems } from './Problems'
import { Titles } from './Titles'

/// functions
/// types
/// components

interface SidebarContentProps {
    dataset: IOrgStageCoordsGetterOutput
}

export const SidebarContent: React.FC<SidebarContentProps> = observer(({
    dataset
}) => {

    const { selection } = useContext(RootStoreContext)


    const T = (props: { children: ReactNode }) => <h2 style={{ textAlign: 'center' }}>{props.children}</h2>

    return <Box className='sidebar-content'>

        <Switch>
            <Case condition={selection.view === 'stages'} children={<T>Процеси реєстрації та обміну даними про випадки та причини смерті</T>} />
            <Case condition={selection.view === 'documents'} children={<T>Документи</T>} />
            <Case condition={selection.view === 'problems'} children={<T>Проблеми</T>} />
            <Case condition={selection.view === 'structure'} children={<T>Структура</T>} />
        </Switch>


        <When condition={!selection.org && !selection.stage && !selection.doc}>
            <Titles />
        </When>


        {/* Basic data for selected stage  */}
        <When condition={selection.stage}>
            <p>Етап: <b>{getStageInfo(selection.stage).stageName}</b>
                <CloseIcon onClick={() => selection.setStage(null)} />
            </p>
            {/* Опис етапу, тільки на режимі етапи */}
            <When condition={selection.view === 'stages'}>
                <p>{getStageInfo(selection.stage).stageDesc}</p>
            </When>


        </When>


        {/* Basic data for selected organization */}
        <When condition={selection.org}>
            <p>
                Організація: <b>{getOrgInfo(selection.org).orgFullname}</b>
                <CloseIcon onClick={() => selection.setOrg(null)} />
            </p>
            {/* <p><b>{getOrgInfo(selection.org).orgFullname}</b></p> */}
            {/* Опис організації */}
            <p>{getOrgInfo(selection.org).orgDesc}</p>


         

        </When>

        {/* Basic data for selected documents */}
        <When condition={selection.doc}>
            <p>
                Документ: <b>{getDocInfo(selection.doc).fullname}</b>
                <CloseIcon onClick={() => selection.setDoc(null)} />
            </p>
            {/* Doc descriptions */}
            {getDocInfo(selection.doc).desc.map(paragraph => (
                <p>{paragraph}</p>
            ))}

       
        </When>


        {/* Basic data for selected problem */}
        <When condition={selection.problem}>
            <p>
                Проблема: <b>{getProblemInfo(selection.problem).problemName}</b>
                <CloseIcon onClick={() => selection.setProblem(null)} />
            </p>

            {getProblemInfo(selection.problem).problemDesc.map(paragraph => (
                <p>{paragraph}</p>
            ))}

      
        </When>

        {/* <HorizontalLine /> */}



        {/* 
            Список організацій пов'язаних з обраним етапом.
            При кліку перехід на режим Структура
            // Не показуються на режимах Документи - Проблеми
            // Не показують коли обрано організацію
        */}
        <When condition={selection.view !== 'documents' && selection.view !== 'problems' && !selection.org}>
            <When condition={selection.stage}>
                <Organizations forStage={selection.stage} />
            </When>

            <When condition={selection.doc}>
                <Organizations forDoc={selection.doc} />
            </When>
        </When>





        {/* Список етапів у яких зустрічається обрана організація */}
        <When condition={selection.org && getStagesForOrg(selection.org).length}>
            <Stages forOrg={selection.org} />
        </When>


        <When condition={selection.view === 'stages'}>
            <When condition={selection.org && selection.stage}>
                <Documents forOrg={selection.org} forStage={selection.stage} />
            </When>
            <When condition={!selection.org && selection.stage}>
                <Documents forStage={selection.stage} />
            </When>
            <When condition={selection.org && !selection.stage}>
                <Documents forOrg={selection.org} />
            </When>
            
        </When>


        {/* Список документів у яких зустрічається обрана організація */}
        <When condition={selection.view !== 'stages' && selection.org && getDocsForOrg(selection.org).length}>
            <Documents forOrg={selection.org} />
        </When>


        {/* Режим документи список документів для обраного етапу */}
        <When condition={selection.view === 'documents' && selection.stage && !selection.doc}>
            <Documents forStage={selection.stage} />
        </When>


        {/* Режим проблеми список проблеми для обраного етапу */}
        <When condition={selection.view === 'problems' && selection.stage && !selection.problem}>
            <Problems forStage={selection.stage} />
        </When>

    </Box>
})





export const HorizontalLine = () => (
    <hr style={{ height: 1, border: '1px solid rgba(0,0,0,0.06)' }} />
)



export const Li = (props: { children: React.ReactNode, id: string, onClick: () => void }) => {

    const [hovered, setHovered] = useState(false)

    return (
        <li
            onMouseOver={() => setHovered(true)}
            onMouseOut={() => setHovered(false)}
            id={props.id}
            onClick={props.onClick}
            style={{
                cursor: "pointer",
                textDecoration: hovered ? 'underline' : undefined
            }}
            children={props.children}
        />
    )
}